module.exports = __webpack_public_path__ + "static/media/adrianUrena.0f465dda.jpg";